var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Applicants',_vm._g(_vm._b({attrs:{"title":"Domestic Applicants","subject":"Domestic Applicant"}},'Applicants',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }